export const newAbortError = (message = 'aborted') => {
  return new DOMException(message, 'AbortError');
};

export const isAbortError = (error: any): error is DOMException => {
  return error instanceof DOMException && error.name === 'AbortError';
};
